<script setup lang="ts">
import {useEnvironment} from "~/stores/spaces";
import {
  AlarmIcon,
  BriefcaseIcon,
  BuildingSkyscraperIcon,
  BuildingStoreIcon,
  CircleDotIcon,
  DeviceDesktopCodeIcon,
  GaugeIcon,
  HeartRateMonitorIcon,
  MailCodeIcon,
  ProgressIcon,
  SettingsIcon,
  TableIcon,
  TriangleSquareCircleIcon,
  WaveSquareIcon, WebhookIcon
} from "vue-tabler-icons";
import LogoServer from "~/components/logo/server.vue";

const {isEnterprise, isEnterpriseWithoutEnterpriseLicense, baseUrl, environment} = useEnvironment()
const {workspacesWithoutDemo} = storeToRefs(useSpacesStore())

const {extraWide} = storeToRefs(useCustomizerStore());

const insightItems = computed(() => {
  const baseValue = baseUrl.value
  const items = ([
    {
      title: 'Dashboard',
      icon: HeartRateMonitorIcon,
      to: `${baseValue}`
    },
    {
      title: 'Applications',
      icon: TriangleSquareCircleIcon,
      to: `${baseValue}/applications`,
    },
    {
      title: 'Processors',
      icon: WaveSquareIcon,
      to: `${baseValue}/processor`,
    },
    {
      title: 'Aggregates',
      icon: CircleDotIcon,
      to: `${baseValue}/aggregates`,
    },
    {
      title: 'Handler Insights',
      icon: GaugeIcon,
      to: `${baseValue}/handlers`,
    },
    {
      title: 'Message Flow',
      icon: MailCodeIcon,
      to: `${baseValue}/flow`,
    },
  ])
  return items
})

const infrastructureItems = computed(() => {
  const baseValue = baseUrl.value
  const items = []
  if (!isEnterpriseWithoutEnterpriseLicense.value) {
    items.push({
      title: 'Axon Server',
      icon: LogoServer,
      to: `${baseValue}/server`
    })
  }
  items.push({
    title: 'Monitoring',
    icon: AlarmIcon,
    to: `${baseValue}/monitoring/conditions`,
  })
  items.push({
    title: 'Integrations',
    icon: WebhookIcon,
    to: `${baseValue}/monitoring/integrations`,
  })
  items.push(
      {
        title: 'Usage',
        icon: ProgressIcon,
        to: `${baseValue}/usage`,
      }
  )
  return items
})

const settingItems = computed(() => {
  const baseValue = baseUrl.value
  const items = [
    {
      title: 'Settings',
      icon: SettingsIcon,
      to: `${baseValue}/settings/general`,
    },
  ];
  if (!isEnterprise.value) {
    items.push(
        {
          title: 'Subscription',
          icon: BuildingStoreIcon,
          to: `${baseValue}/subscription`,
        })
  }
  return items
})

const workspaceItems = computed(() => {
  return workspacesWithoutDemo.value.map(ws => {
    return {
      name: ws.name,
      environments: ws.environments.map(env => {
        let icon = DeviceDesktopCodeIcon
        if (env.featureSet.type === "SUBSCRIPTION") {
          icon = BriefcaseIcon
        } else if (env.featureSet.type === "ENTERPRISE") {
          icon = BuildingSkyscraperIcon
        }
        return ({
          title: env.name,
          icon: icon,
          to: `/workspace/${ws.identifier}/env/${env.identifier}/`,
        });
      })
    }
  })
})
</script>

<template>
  <div v-if="environment">
    <MenuRouteBased :title="extraWide ? undefined : 'Insights'" :items="insightItems"/>
    <MenuRouteBased :title="extraWide ? undefined : 'Operations'" :items="infrastructureItems"/>
    <MenuRouteBased :title="extraWide ? undefined : 'Settings'" :items="settingItems"/>
  </div>
  <div v-if="!environment">
    <template v-for="workspace in workspaceItems">
      <MenuRouteBased :title="workspace.name" :items="workspace.environments"/>
    </template>
  </div>
</template>
